export default "__VITE_ASSET__KvPAqDjQ__"